import React from "react";

function CameraStartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="99.701"
      height="97.912"
      viewBox="0 0 99.701 97.912"
    >
      <g
        id="Play_Icon"
        data-name="Play Icon"
        transform="translate(-142.429 -678)"
      >
        <path
          id="Path_475"
          data-name="Path 475"
          d="M70.347,46.245"
          transform="translate(72.082 723.048)"
          fill="#fff"
        />
        <g
          id="Ellipse_2"
          data-name="Ellipse 2"
          transform="translate(144.218 678)"
          fill="none"
          stroke="#fff"
          strokeWidth="4"
        >
          <circle cx="48.956" cy="48.956" r="48.956" stroke="none" />
          <circle cx="48.956" cy="48.956" r="46.956" fill="none" />
        </g>
        <circle
          id="Ellipse_3"
          data-name="Ellipse 3"
          cx="39.848"
          cy="39.848"
          r="39.848"
          transform="translate(153.326 687.108)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default CameraStartIcon;
